import React from 'react';

const Img= function(props:any){
    return <img alt="" {...props } />
}

const Div= function(props:any){
    return <div {...props } />
}
const P= function(props:any){
    return <p {...props } />
}
const Input= function(props:any){
    return <input {...props } />
}
const Label= function(props:any){
    return <label {...props } />
}
const Span= function(props:any){
    return <span {...props } />
}

const Form= function(props:any){
    return <form {...props } />
}

export {
    Div,
    Img,
    Label,
    Span,
    Input,
    P,
    Form
};
